;(function() {
  'use strict'

  Profile.$inject = ["$scope", "$state", "$timeout", "$log", "glDialog", "glError", "userService", "suburbService"];
  angular.module('app.profile').controller('Profile', Profile)

  // --------------------

  /* @ngInject */
  function Profile(
    $scope,
    $state,
    $timeout,
    $log,
    glDialog,
    glError,
    userService,
    suburbService
  ) {
    var log = $log.create('Profile')
    var suggestTimer

    $scope.logout = logout
    $scope.data = {}
    $scope.save = save
    $scope.suggestSuburbs = suggestSuburbs
    $scope.setSuburb = setSuburb
    $scope.usernameChecker = userService.getUsernameChecker()
    $scope.user = _.clone($scope.app.user)

    init()

    function init() {
      if (!userService.loggedIn()) {
        return glError.unauthorized()
      }
      makeYears()
      makeGenders()
    }

    function makeYears() {
      var years = []
      var currentYear = moment().year()
      for (var numYears = 100; numYears > 0; numYears--) {
        years.push(currentYear - numYears)
      }
      years.push(currentYear)
      years.reverse()
      $scope.data.years = years
    }

    function makeGenders() {
      $scope.data.genders = ['Male', 'Female']
    }

    function suggestSuburbs() {
      if (suggestTimer) {
        $timeout.cancel(suggestTimer)
      }
      $scope.user.state = undefined
      suggestTimer = $timeout(function() {
        if (!$scope.user.suburb) {
          $scope.data.suggestedSuburbs = undefined
          return
        }
        $scope.data.suggestedSuburbs = suburbService.search($scope.user.suburb)
      }, 250)
    }

    function setSuburb(suburb) {
      $scope.data.suggestedSuburbs = undefined
      $scope.user.suburb = suburb.name
      $scope.user.state = suburb.state
    }

    function save() {
      if ($scope.user.suburb && !$scope.user.state) {
        return glDialog.alert('', 'Please select a suburb from the list')
      }
      $scope.data.loading = true
      userService.update($scope.user).then(
        function() {
          $scope.data.loading = false
          glDialog.alert('', 'Your profile has been saved.')
        },
        function(err) {
          $scope.data.loading = false
          glDialog.alert('', err)
          log.error('error')
        }
      )
    }

    function logout() {
      userService.logout().then(function() {
        $state.go('app.public')
      })
    }
  }
})()
